module.exports = __webpack_public_path__ + "static/media/Jon_Ashby.4042a7f8.jpg";